import request from "./request";
/**
 * 我的专页列表
 * @param blendParam 专页id或者标识id
 */
export default async function getMyPageInfoPage(params = {}) {
  const defaultParams = {
    pageNumber: 1,
    pageSize: 10,
  };
  return await request.get("/spin/dataAuthorizationPlayer/getMyPageInfoPage", {
    params: { ...defaultParams, ...params },
  });
}
